import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, switchMap, withLatestFrom } from 'rxjs/operators';
import { UserProfileService } from './userprofile.service';
import {
	loadUserProfileAction,
	loadUserProfileSuccessAction,
	updateUserProfileAction,
	updateUserProfileSuccessAction,
} from './userprofile.actions';
import { UserProfileFacade } from './userprofile.facade';

@Injectable()
export class UserProfileEffects {
	constructor(
		private actions: Actions,
		private userProfileService: UserProfileService,
		private userProfileFacade: UserProfileFacade
	) {}

	loadUserProfile = createEffect(() =>
		this.actions.pipe(
			ofType(loadUserProfileAction),
			switchMap(({ user }) => {
				return this.userProfileService
					.getProfile(user)
					.pipe(map(userProfile => loadUserProfileSuccessAction({ userProfile })));
			})
		)
	);

	updateUserProfile = createEffect(() =>
		this.actions.pipe(
			ofType(updateUserProfileAction),
			withLatestFrom(this.userProfileFacade.profile),
			switchMap(([{ userProfile }, profileToUpdate]) => {
				return this.userProfileService
					.updateProfile(profileToUpdate, userProfile)
					.pipe(map(userProfile => updateUserProfileSuccessAction({ userProfile })));
			})
		)
	);
}
